export const FETCH_DASHBOARD_TUT_STATUS_SUCCESS = 'FETCH_DASHBOARD_TUT_STATUS_SUCCESS';
export const UPDATE_DASHBOARD_TUT_STATUS = 'UPDATE_DASHBOARD_TUT_STATUS';
